import React from 'react';
// Constants
import { CompanyName } from '../../utils/Constants';
// Data
import {
  contactPageAdditionalMeta,
  contactPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import ContactPageMainContainer from '../../components/contact/ContactPageMainContainer';
import FooterComponent from '../../components/footer/FooterComponent';

function ContactPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Contact'
        desc={`Get in touch with ${CompanyName} for expert web and circuit design services. We're here to help with your inquiries, quotes, or support needs.`}
        keywords={`contact, web design, circuit design, ${CompanyName}, customer support, inquiries, quotes, UK`}
        additionalMeta={contactPageAdditionalMeta}
        structuredData={contactPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        {/* Navigation */}
        <Navbar />

        {/* Header */}
        <header className='grid w-full pt-[84px]'>
          <div className='grid w-full px-6 gap-y-6 lg:container lg:mx-auto text-center py-10'>
            <h1 className='text-3xl font-extrabold tracking-tight font-titleFont text-colour2 md:text-4xl dark:text-colour1'>
              Get in Touch
            </h1>
            <p className='text-base md:text-lg text-colour8 dark:text-colour3 max-w-2xl mx-auto'>
              Have questions, need a quote, or just want to say hello?  
              {` ${CompanyName}`} is here to help you move your project forward.
            </p>
            <p>Contact Form Below</p>
          </div>
        </header>

        {/* Main page content */}
        <ContactPageMainContainer />

        <FooterComponent />
      </div>
    </>
  );
}

export default ContactPage;
